import { FormProvider, useForm } from 'react-hook-form';
import { StudentRiskObservationsFormLoader } from '../loaders/StudentRiskObservationsFormLoader';
import { StudentRiskObservationsFilters } from './StudentRiskObservationsFilters';
import { StudentRiskObservationsList } from './StudentRiskObservationsList';
import { StudentRiskObservationsFiltersFormFields } from '../types';
import { StudentRiskObservationsStudentListLoader } from '../loaders/StudentRiskObservationsStudentListLoader';

const defaultPagination = {
  items_per_page: 10,
  page: 1,
};

export function StudentRiskObservations() {
  const methods = useForm<StudentRiskObservationsFiltersFormFields>({
    defaultValues: {
      studyPlan: null,
      campus: null,
      school: null,
      nameOrId: null,
    },
  });

  return (
    <StudentRiskObservationsFormLoader fetchImmediately>
      <StudentRiskObservationsStudentListLoader
        defaultQuery={{
          schoolId: undefined,
          ...defaultPagination,
        }}
      >
        <FormProvider {...methods}>
          <StudentRiskObservationsFilters
            defaultPagination={defaultPagination}
          />
          <StudentRiskObservationsList />
        </FormProvider>
      </StudentRiskObservationsStudentListLoader>
    </StudentRiskObservationsFormLoader>
  );
}
